import React from "react";
import Header from "../../../../ui-components/LandingPage/ExtensionUi/Header";
import TestimonialOne from "../../../../ui-components/LandingPage/ExtensionUi/TestimonialOne";
import Card from "../../../../ui-components/LandingPage/ExtensionUi/Card";
import TestimonialThree from "../../../../ui-components/LandingPage/ExtensionUi/TestimonialThree";
import TestimonialTwo from "../../../../ui-components/LandingPage/ExtensionUi/TestimonialTwo";
import Context from "../../../../ui-components/LandingPage/ExtensionUi/Context";

const Extension = () => {
  return (
    <>
      {/* <div className="min-[2000px]:px-36"> */}
        <Header />
        <TestimonialOne />
        <Card />
        <TestimonialThree />
        <TestimonialTwo />
        <Context />
      {/* </div> */}
    </>
  );
};

export default Extension;